// @Version: 1.0.0
import { Pipe, PipeTransform } from '@angular/core';
import { COLOR, POSITION } from 'src/app/shared/components/field-item/field-item.model';
import { FieldItemService } from 'src/app/shared/components/field-item/field-item.service';

@Pipe(
	{ name: 'posAndColor', 
		standalone: true 
	})
	export class PosAndColorPipe implements PipeTransform {

		constructor (private sFieldItem: FieldItemService) {

		}
		/**
		 * 
		 * @param content Inhalt zum Umwandeln
		 * @param element 1: POSITION, 2: COLOR
		 * @param inheritElement: Wenn kein Inhalt da ist.
		 * @returns 
		 */
	public transform(content: string | undefined, element: number, inheritElement: COLOR | POSITION): string {
		switch (element) {
			case 1: 
				return this.sFieldItem.getPos(content, inheritElement as  POSITION);
			case 2:
				return this.sFieldItem.getColor(content, inheritElement as COLOR);
			default: return ''
		};
	}
}
